import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Modal } from "react-bootstrap";
import middleware from "../../../Api/Middleware.js";
import ToastError from "../../../Toasts/ToastError.js";
import ToastSuccess from "../../../Toasts/ToastSuccess.js";
import { ButtonBlue, ButtonLightGrey } from "../../../HouseStyle/Components/Buttons.js";
import { BorderedTextInput } from "../../../HouseStyle/Components/Inputs.js";
import { BorderedDropDown } from "../../../HouseStyle/Components/DropDowns.js";
import LoadingIcon from "../../../HouseStyle/Components/LoadingIcon.js";
import "../../../Modals/ModalStyle.css";

function GiftcardEditModal({ show, setShow, giftcard, onSuccess }) {
    const [card, setCard] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(false);
    const navigate = useNavigate();

    // Fetch full card details when modal opens
    useEffect(() => {
        if (giftcard && show) {
            fetchCardDetails();
        }
    }, [giftcard, show]);

    const fetchCardDetails = async () => {
        try {
            setLoadingData(true);
            const response = await middleware.get(`giftcards?card_id=${giftcard.card_id}`);
            setCard(response.data.data);
        } catch (error) {
            ToastError('Fout bij het ophalen van de data');
        } finally {
            setLoadingData(false);
        }
    };

    const formatCardNumber = (num) => {
        if (!num) return '';
        const str = num.toString();
        if (str.length === 13) {
            return `${str[0]}-${str.slice(1, 7)}-${str.slice(7, 13)}`;
        }
        return str.match(/.{1,4}/g)?.join('-') || str;
    };

    const handleClose = () => {
        setCard(null);
        setShow(false);
    };

    const handleStatusChange = async (newStatus) => {
        setCard(prevCard => ({ ...prevCard, status: newStatus }));
        
        setLoading(true);
        try {
            await middleware.put(`giftcards`, { 
                card_id: card.card_id, 
                status: newStatus 
            });
            ToastSuccess('Cadeaukaart succesvol bijgewerkt');
            if (onSuccess) onSuccess();
        } catch (error) {
            console.error(error);
            ToastError('Fout bij het bijwerken van de cadeaukaart');
        } finally {
            setLoading(false);
        }
    };

    const openMutations = () => {
        const giftcardData = card;
        if (!giftcardData) {
            return;
        }
        navigate("/algemene/instellingen/cadeaukaarten/mutaties", {
            state: { giftcard: giftcardData }
        });
    };

    return (
        <Modal 
            show={show && giftcard}
            onHide={handleClose}
            className="modalEditLabel"
            centered
            size="m"
        >
            <Modal.Header className="modalTop justify-content-between" closeButton>
                <Modal.Title>Cadeaukaart bewerken</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modalCenter">
                {loadingData ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                        <LoadingIcon />
                    </div>
                ) : card ? (
                    <div className="d-flex flex-column gap-3">
                        <BorderedTextInput 
                            label="Kaartnummer" 
                            inputValue={formatCardNumber(card.card_number)}
                            disabled={true}
                        />
                        <BorderedDropDown
                            label="Status"
                            placeholder=""
                            options={[
                                { title: "Inactief", value: "0" },
                                { title: "Actief", value: "1" },
                                { title: "Geblokkeerd", value: "2" },
                            ]}
                            selectedValue={card.status.toString()}
                            setSelectedValue={handleStatusChange}
                        />
                    </div>
                ) : null}
            </Modal.Body>
            <Modal.Footer className="modalBottom d-flex">
                <ButtonBlue 
                    text="Sluiten" 
                    disabled={loading} 
                    onClickFunction={handleClose} 
                    size=""
                />
                <ButtonLightGrey className="modalButton"
                    text="Mutaties"
                    disabled={loading || !(card || giftcard)?.card_id}
                    onClickFunction={openMutations}
                    size=""
                />
            </Modal.Footer>
        </Modal>
    );
}

export default GiftcardEditModal;